export default "__VITE_ASSET__DkcSKX1k__"